import IntersectionObserver from 'intersection-observer-polyfill';

const observer = ($el) => new Promise((resolve) => {
  function intersected(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        resolve();
      }
    });
  }
  const options = {
    rootMargin: '400px', // значение отступа от элемента
  };
  const intersect = new IntersectionObserver(intersected, options);
  intersect.observe($el);
});

export default observer;
